export default {
  customDashboard: {
    loading: 'Caricamento...',
    loadingData: 'Caricamento dati...',
    selectedSensors: '{count} sensori selezionati',
    addNewChart: 'Aggiungi nuovo grafico',
    chartTitle: 'Titolo grafico',
    selectSensors: 'Seleziona sensori',
    selectSensorValidation: 'Seleziona almeno un sensore',
    chartType: 'Tipo di grafico',
    selectChartType: 'Seleziona un tipo di grafico',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    invalidDateRange: 'Intervallo date non valido',
    sensorColors: 'Colori sensori',
    others: 'altri',
    buttons: {
      cancel: 'Annulla',
      confirm: 'Conferma',
      update: 'Aggiorna'
    },
    editChart: 'Modifica grafico',
    buttonColors: {
      green: '{sensorName} - Verde',
      yellow: '{sensorName} - Giallo',
      red: '{sensorName} - Rosso'
    },
    selectDateRange: 'Seleziona intervallo date',
    quickFilters: 'Filtri Rapidi',
    weeklyConsumption: 'Consumo Settimanale',
    dataManager: 'Gestione Dati',
    lastRefilling: 'Ultimo Rifornimento',
    dispenserLevel: 'Livello Dispenser',
    time: 'Orario',
    levelStatus: 'Stato Livello',
    fullEmptyDispenser: 'Dispenser Pieno/Vuoto',
    emptyHours: 'Ore Vuoto',
    consumptions: 'Consumi',
    downloadChartData: 'Scarica Dati Grafico',
    downloadAllData: 'Scarica Tutti i Dati',
    addNewWidget: 'Aggiungi nuovo widget',
    widgetType: 'Tipo di widget',
    chartTemplate: 'Template grafico',
    comparisonLevel: 'Livello di confronto',
    entitiesToCompare: 'Entità da confrontare',
    period: 'Periodo',
    widgetTitle: 'Titolo widget',
    size: 'Dimensione',
    filters: {
      title: 'Filtri',
      clients: 'Clienti',
      buildings: 'Edifici',
      floors: 'Piani',
      areas: 'Aree',
      dispenserType: 'Tipologia Dispenser',
      productType: 'Tipologia Prodotto',
      selectAll: 'Seleziona tutto',
      deselectAll: 'Deseleziona tutto'
    },
    sizes: {
      small: 'Piccolo',
      medium: 'Medio',
      large: 'Grande'
    },
    kpiType: 'Tipo KPI',
    dataLevel: 'Livello dati',
    articleType: 'Tipo articolo',
    edit: 'Modifica',
    delete: 'Elimina',
    kpiTypes: {
      totalConsumption: {
        title: 'Consumo Totale Carta',
        description: 'Totale della carta consumata nel periodo selezionato'
      },
      averageDaily: {
        title: 'Consumo Medio Giornaliero',
        description: 'Media giornaliera del consumo di carta'
      },
      mostUsedArticle: {
        title: 'Articolo Più Utilizzato',
        description: 'Tipo di carta più utilizzata, in percentuale sul totale'
      },
      inactiveZones: {
        title: 'Zone Inattive',
        description: 'Numero di zone senza attività rilevata'
      },
      estimatedCost: {
        title: 'Costo Stimato Carta',
        description: 'Costo stimato della carta consumata'
      },
      peakUsageDay: {
        title: 'Giorno Picco Utilizzo',
        description: 'Giorno con la frequenza d\'uso più alta nel periodo'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Consumo Carta',
        description: 'Confronto sul consumo totale di carta'
      },
      usageFrequency: {
        title: 'Frequenza Utilizzo',
        description: 'Confronto sulla frequenza d\'uso delle aree o dei dispenser'
      },
      paperCost: {
        title: 'Costo Carta',
        description: 'Confronto sul costo stimato legato all\'uso della carta'
      },
      alertEvents: {
        title: 'Eventi Alert',
        description: 'Confronto sul numero di eventi di alert registrati'
      },
      consumptionVsFrequency: {
        title: 'Consumo vs Frequenza',
        description: 'Confronto tra il consumo giornaliero e la frequenza di utilizzo di un\'area'
      },
      sensorComparison: {
        title: 'Confronto Sensori',
        description: 'Confronto tra serie storiche di sensori selezionati'
      },
      consumptionVsBathroom: {
        title: 'Consumo vs Utilizzo Bagno',
        description: 'Correlazione tra consumo carta e frequenza di utilizzo del bagno'
      }
    },
    sensorCategories: {
      dispenser: 'Dispenser',
      doors: 'Porte'
    },
    sensorComparison: {
      title: 'Confronto Sensori',
      selectSensors: 'Seleziona sensori da confrontare',
      selectCategory: 'Seleziona categoria',
      noSensorsSelected: 'Seleziona almeno un sensore per il confronto',
      loading: 'Caricamento dati sensori...'
    }
  },
  sensor: {
    error: {
      loading: 'Errore nel caricamento dei dettagli del sensore',
      updating: 'Errore nell\'aggiornamento del sensore',
      requiredFields: 'Compilare tutti i campi obbligatori',
      title: 'Errore',
      emptyFields: 'I seguenti campi sono obbligatori: {fields}',
      duplicateDevEui: 'Questo ID sensore esiste già nel sistema',
      creation: 'Errore nella creazione del sensore',
    },
    add: {
      title: 'CONFIGURAZIONE RAPIDA SENSORE: Compilare i campi sottostanti'
    },
    fields: {
      sensorId: 'ID Sensore',
      dispenserName: 'Nome Dispenser',
      dispenserBrand: 'Marca Dispenser',
      dispenserArticleCode: 'Codice Articolo Dispenser',
      consumableBrand: 'Marca Consumabile',
      consumableArticleCode: 'Codice Articolo Consumabile',
      client: 'Cliente',
      building: 'Edificio',
      floor: 'Piano',
      area: 'Area'
    },
    selectDispenser: 'Seleziona Dispenser',
    notManagedYet: 'Non ancora gestito',
    emptyHours: 'Ore Vuoto',
    full: 'Pieno',
    empty: 'Vuoto'
  },
  login: {
    title: 'Accesso',
    button: 'Accedi',
    username: 'Nome utente',
    password: 'Password',
    error: 'Nome utente o password non corretti!',
    close: 'Chiudi',
    forgotPassword: 'Password dimenticata',
    resetPassword: 'Reimposta Password',
    resetPasswordInstructions: 'Inserisci l\'email utilizzata durante la registrazione',
    email: 'Email',
    resetRequested: 'Reset richiesto per:',
    enterNewPassword: 'Inserisci la nuova password nei campi sottostanti (assicurati che entrambe le password siano uguali per procedere)',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma nuova password',
    passwordsDontMatch: 'Le password non corrispondono'
  },
  KEY001: 'Accesso',
  key006: 'Nome utente o password non corretti!',
  key007: 'Chiudi',
  validation: {
    required: 'Questo campo è obbligatorio',
    duplicateDevEui: 'Questo ID sensore esiste già'
  },
  building: {
    add: {
      title: 'CREA NUOVO EDIFICIO: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome edificio',
      address: 'Indirizzo edificio'
    },
    error: {
      creation: 'Errore nella creazione dell\'edificio'
    }
  },
  floor: {
    add: {
      title: 'CREA NUOVO PIANO: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome piano',
      building: 'Edificio'
    },
    error: {
      creation: 'Errore nella creazione del piano'
    }
  },
  area: {
    add: {
      title: 'CREA NUOVA AREA: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome area',
      building: 'Edificio',
      floor: 'Piano'
    },
    error: {
      creation: 'Errore nella creazione dell\'area'
    }
  },
  washroomFrequency: {
    selectSensor: 'Seleziona un sensore bagno per continuare',
    loading: 'Caricamento...',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    sensor: 'Sensore',
    back: 'INDIETRO',
    ok: 'OK',
    quickFilters: 'Filtri rapidi:',
    hours: '4 ORE',
    day: '1 GIORNO',
    week: '1 SETTIMANA',
    twoWeeks: '2 SETTIMANE',
    thirtyDays: '30 GIORNI',
    selectDateRange: 'Seleziona intervallo date',
    cancel: 'Annulla',
    dataManager: 'GESTIONE DATI',
    sensorName: 'Nome sensore:',
    cleaningSchedule: 'PROGRAMMA PULIZIE',
    washroomUsageFrequency: 'FREQUENZA UTILIZZO BAGNO',
    lastCleaning: 'Ultima pulizia:',
    cleaningStatus: 'Stato pulizia:',
    alertThreshold: 'Soglia Alert:',
    events: 'Eventi',
    cleaningRequired: 'Pulizia Richiesta',
    mightNeedClean: 'Potrebbe necessitare pulizia',
    doesntNeedClean: 'Non necessita pulizia'
  },
  manageSensors: {
    title: 'Gestione Sensori',
    addNewSensor: 'Aggiungi nuovo sensore',
    sensorDeleting: 'Eliminazione Sensore',
    deleteConfirm: 'Sei sicuro di voler eliminare "{name}"?',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    sensor: 'Sensore',
    clearFilter: 'Rimuovi filtri',
    filter: 'Filtra',
    type: 'Tipo',
    fillLevel: 'Livello riempimento',
    liveUsage: 'Utilizzo corrente',
    cleaningLimit: 'Soglia pulizia',
    name: 'Nome',
    company: 'Azienda',
    battery: 'Batteria',
    sensorId: 'ID Sensore',
    actions: 'Azioni',
    editSensor: 'MODIFICA SENSORE',
    update: 'Aggiorna',
    noDataAvailable: 'Nessun dato disponibile'
  },
  alerts: {
    title: 'Avvisi',
    alertTime: 'ORA AVVISO',
    solvedTime: 'ORA RISOLUZIONE',
    message: 'MESSAGGIO',
    markAsDone: 'Segna come completato',
    triggerAt: 'Attivato il',
    resolvedAt: 'Risolto il',
    duration: 'Durata'
  },
  dashboard: {
    title: 'Cruscotto',
    overview: 'Panoramica',
    statistics: 'Statistiche',
    editWidget: 'Modifica Widget',
    addWidget: 'Aggiungi Widget',
    widgetSize: 'Dimensione Widget',
    size: 'Dimensione',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    sizes: {
      small: 'Piccolo',
      smallDesc: 'Larghezza 1/4 - Widget compatti',
      medium: 'Medio',
      mediumDesc: 'Larghezza 1/2 - Widget standard',
      large: 'Grande',
      largeDesc: 'Larghezza completa - Widget grandi'
    }
  },
  alertsManagement: {
    pageTitle: 'Gestione Avvisi',
    createRule: 'Crea nuova regola',
    fillFields: 'Compilare i campi sottostanti',
    title: 'Titolo',
    email: 'email (usa ; per separare le email)',
    customMessage: 'Inserisci qui il tuo messaggio personalizzato:',
    alertValue: 'Valore Alert (%) - n. eventi',
    saveRule: 'Salva regola',
    sensor: 'SENSORE',
    emailAddresses: 'INDIRIZZI EMAIL',
    active: 'ATTIVO',
    phoneNumbers: 'NUMERI TELEFONO',
    deleteConfirm: {
      title: 'Conferma Eliminazione',
      message: 'Sei sicuro di voler eliminare la regola "{title}"?',
      description: 'Questa azione non può essere annullata.'
    }
  },
  users: {
    title: 'Utenti',
    manageUser: 'Gestisci Utente',
    username: 'NOME UTENTE',
    role: 'RUOLO',
    active: 'ATTIVO'
  },
  buildings: {
    title: 'Edifici',
    name: 'Nome',
    address: 'Indirizzo',
    sensors: 'Sensori'
  },
  smartDispenser: {
    selectSensor: 'Seleziona un dispenser smart per continuare',
    loading: 'Caricamento...',
    quickFilters: 'Filtri rapidi:',
    hours: '4 ORE',
    day: '1 GIORNO',
    threeDays: '3 GIORNI',
    week: '1 SETTIMANA',
    twoWeeks: '2 SETTIMANE',
    lastMonth: 'ULTIMO MESE',
    selectDateRange: 'Seleziona intervallo date',
    dataManager: 'GESTIONE DATI',
    sensorName: 'Nome sensore:',
    lastRefill: 'Ultimo rifornimento:',
    consumption: 'Consumo:',
    binLevel: 'LIVELLO CESTINO',
    dispenserLevel: 'LIVELLO DISPENSER',
    dispenserAvailability: 'DISPONIBILITÀ DISPENSER – % PIENO vs VUOTO',
    dispenserDowntime: 'TEMPO INATTIVO DISPENSER – ORE VUOTO / GIORNO',
    consumptions: 'CONSUMI',
    downloadChartData: 'Scarica dati grafico',
    downloadAllData: 'Scarica tutti i dati del sensore',
    refillSchedule: 'PROGRAMMA RIFORNIMENTI',
    levelStatus: 'Stato livello:',
    time: 'Ora:'
  },
  smartBin: {
    selectSensor: 'Seleziona uno smart bin per continuare',
    binLevel: 'LIVELLO BIN',
    binFillLevel: 'LIVELLO RIEMPIMENTO BIN – LIVELLO',
    averageFillingLevel: 'LIVELLO MEDIO DI RIEMPIMENTO',
    fillLevel: 'Livello di riempimento'
  },
  airQuality: {
    selectSensor: 'Seleziona un sensore di qualità dell\'aria per continuare',
    co2Level: 'LIVELLO CO2',
    temperature: 'TEMPERATURA',
    humidity: 'UMIDITÀ',
    averageCo2: 'LIVELLO MEDIO CO2'
  },
  sensorDetails: {
    sensorDetails: 'Dettagli Sensore',
    deviceInfo: 'Informazioni Dispositivo',
    location: 'Posizione',
    status: 'Stato',
    lastUpdate: 'Ultimo Aggiornamento'
  },
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    ok: 'OK',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    add: 'Aggiungi',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    continue: 'Continua',
    search: 'Cerca',
    loading: 'Caricamento...',
    noDataAvailable: 'Nessun dato disponibile',
    yes: 'Sì',
    no: 'No',
    saveChanges: 'Salva Modifiche',
    days: {
      sunday: 'Domenica',
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato'
    }
  },
} 